<template>
    <section v-if="show" class="h-screen">
        <div no-class="fixed inset-0 overflow-hidden">
            <div no-class="absolute inset-0 overflow-hidden">
                <div class="flex flex-wrap bg-blue-50">
                    <div class="flex flex-col w-full">
                        <div class="bg-blue-50 pb-28 stage-bg">
                            <header class="pb-10 pt-6">
                                <div class="mx-auto px-4 sm:px-6 lg:px-8">
                                    <div class="flex items-stretch">
                                        <div class="flex-1 self-center px-1">
                                            <h1
                                                class="text-2xl leading-9 font-bold text-blue-900 stage-text"
                                            >
                                                {{
                                                    t(
                                                        "backstage.title",
                                                        "Backstage"
                                                    )
                                                }}
                                            </h1>
                                            <!-- <h3
                                                class="text-xl font-bold text-blue-900 stage-text"
                                            >
                                                {{
                                                    t("backstage.subtitle", "")
                                                }}
                                            </h3> -->
                                        </div>

                                        <!-- <div class="flex-initial self-end">
                                            <logo-nl
                                                height="h-24"
                                                class="h-24"
                                                v-if="!logo"
                                            ></logo-nl>
                                            <img
                                                :src="logo"
                                                class="h-24 w-auto"
                                                v-if="logo"
                                            />
                                        </div> -->
                                    </div>
                                </div>
                            </header>
                        </div>

                        <main class="-mt-32">
                            <div class="mx-auto pb-12 px-4 sm:px-6 lg:px-8">
                                <div
                                    class="embed-container bg-gray-50 rounded-lg shadow-xl px-5 py-6 sm:px-6 w-full items-center"
                                    v-if="room.type == 'broadcast'"
                                >
                                    <session
                                        v-if="apiKey && token"
                                        :user_name="user_name"
                                        :apiKey="apiKey"
                                        :sessionId="sessionId"
                                        :token="token"
                                        :publishToken="token"
                                        :viewToken="viewToken"
                                        :output="output"
                                        :role="typeOfToken"
                                        :system_role="system_role"
                                    ></session>
                                </div>
                                <vonage-controller
                                    v-if="
                                        meeting &&
                                        room.type == 'broadcast' &&
                                        vonageToolbar
                                    "
                                    class="mt-4"
                                    :streamers="streamers"
                                    :system_role="system_role"
                                    meeting="backstage"
                                    is_started="true"
                                ></vonage-controller>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style scoped>
.OT_subscriber {
    float: right;
}
.OT_publisher {
    float: left;
}
.chrome-only {
    visibility: hidden;
}
@media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    .chrome-only {
        visibility: visible;
    }
}
@supports (-ms-ime-align: auto) {
    .chrome-only {
        visibility: visible;
    }
}
.OT_archiving-status {
    display: none !important;
}
.stage-text {
    display: none !important;
}
</style>

<script>
export default {
    mounted() {
        Eventing.fire("checkAuthStatus");
        // this.getRoom(this.$route.params.slug);

        Eventing.listen(
            "hideVonageToolbar",
            () => (this.vonageToolbar = false)
        );
        // Eventing.listen(
        //     "publishStreamers",
        //     (streamers) => (this.streamers = streamers)
        // );

        Eventing.listen("publishRequest", (source) => this.joinMeeting(source));

        Eventing.listen("removeFromSessionOT", () => this.closePublisher());
        this.apiKey = process.env.MIX_TOK_API;

        // Eventing.listen("invitedForMeeting", () => this.handleInvite());
        // Eventing.listen("startedStreaming", () => this.checkStreamExceeded());
    },
    data() {
        return {
            show: false,
            room: {
                embed: null,
                limit: 0,
                has_broadcast_limit: true,
            },
            broadcast_limit: 2,
            meeting: false,
            session: null,
            apiKey: null,
            token: null,
            sessionId: null,
            user_name: null,
            tenant: null,
            role: null,
            output: "webcam",
            mayPublish: false,
            nowOnline: -1,
            viewToken: null,
            isPublishing: false,
            isLoaded: false,
            embedIVS: false,
            stoppingMeeting: false,
            streamers: null,
            vonageToolbar: false,
            system_role: "subscriber",
            slug: null,
            logo: null,
        };
    },
    created() {
        this.output = this.$route.query.source;
        Eventing.fire("forcedSoftUnpublish");
        this.slug = this.$route.params.slug;

        this.getBackstage();

        setTimeout(() => {
            window.scrollTo({ bottom: 0, behavior: "smooth" });
        }, 2000);

        try {
            setTimeout(() => {
                document.querySelectorAll(".top-header").forEach(function (el) {
                    el.remove();
                });
            }, 2000);
        } catch (error) {
            console.warn(error);
        }
    },
    beforeMount() {
        console.info("beforeMount");
        Eventing.fire("forcedSoftUnpublish");
        this.show = false;
    },
    beforeUnmount() {
        console.info("beforeUnmount");
        this.show = false;
        Eventing.fire("forcedSoftUnpublish");
        // console.log("this.$route.params.slug: " + this.slug);
        // this.getRoom(this.slug);
        if (this.system_role != "subscriber") {
            Eventing.fire("stopSession");
        }
        // window.location.reload();
    },
    methods: {
        closePublisher() {
            this.mayPublish = false;

            if (
                this.system_role != "moderator" &&
                this.system_role != "publisher"
            ) {
                this.vonageToolbar = false;
            } else {
                // setTimeout(() => {
                //     window.location.reload();
                // }, 200);
            }
            this.vonageToolbar = false;
            // this.show = false;
            // this.getRoom();
        },
        setLogo() {
            try {
                this.logo =
                    document.head.querySelector('meta[name="logo"]')?.content;
            } catch (error) {}
        },
        joinMeeting(source) {
            let self = this;
            self.mayPublish = true;
            Eventing.fire("changeOfOpenTokToken", "webcam");
            Eventing.fire("resetPublishSource", "webcam");

            setTimeout(() => {
                Eventing.fire("streamsFromBackstage");
            }, 100);

            // axios
            //     .get("/api/rooms/" + this.room.slug)
            //     .then((response) => {
            //         console.info(response.data);
            //         self.mayPublish = true;
            //         Eventing.fire("changeOfOpenTokToken", source);
            //         Eventing.fire("resetPublishSource", source);
            //     })
            //     .catch((error) => {
            //         if (error.response) {
            //             if (error.response.status > 300) {
            //                 return (window.location = "/app#/dashboard");
            //             }
            //         }
            //     });
        },
        stopMeeting() {
            this.stoppingMeeting = true;
        },
        getTrans(text) {
            let self = this;
            if (text == "tts.babbelbox.join") {
                return self.t("tts.babbelbox.join", {
                    available: self.room.limit - self.nowOnlineInRoom,
                    limit: self.room.limit,
                });
            }
            return self.t(text);
        },
        startShare(output) {
            this.$router.replace({
                name: "backstage",
                params: { slug: this.$route.params.slug },
                query: { source: output },
            });
        },
        getBackstage() {
            console.log("getBackstage");
            var self = this;
            axios
                .get("/api/backstage")
                .then((response) => {
                    console.info(response.data.data);
                    // self.meeting = response.data.data.room;
                    self.room = response.data.data.room;
                    self.broadcast_limit = parseInt(
                        response.data.broadcast_limit
                    );
                    self.token = response.data.token;
                    self.viewToken = response.data.view_token;
                    self.viewToken = response.data.token;
                    if (!response.data.view_token) {
                        self.viewToken = response.data.token;
                    }
                    self.sessionId = response.data.data.room.session_id;
                    self.user_name = response.data.user_name;
                    self.role = response.data.role;
                    if (!self.show) {
                        self.show = true;
                    }

                    self.system_role = response.data.system_role;

                    // if (confirm(self.system_role)) {
                    if (self.system_role == "moderator") {
                        self.vonageToolbar = true;
                    } else if (self.system_role == "publisher") {
                        self.vonageToolbar = true;
                        setTimeout(() => {
                            self.meeting = true;
                            // Eventing.fire("notify", {
                            //     title: "Webcam wordt gestart",
                            //     message:
                            //         "Je webcam wordt als het goed is nu gestart (dit is een debug melding)",
                            //     type: "success",
                            // });
                            console.warn("Je webcam gaat nu starten");
                            // Eventing.fire("joinWithCam");
                            self.joinMeeting("webcam");
                        }, 1000);
                    } else {
                        self.vonageToolbar = false;
                    }
                    // }
                    self.setLogo();
                })
                .catch((error) => {
                    if (error.response) {
                        if (error.response.status > 300) {
                            return (window.location = "/app#/dashboard");
                        }
                    }
                });
        },
        errorHandler(err) {
            alert(err.message);
        },
    },
    watch: {},
    computed: {
        typeOfToken() {
            return this.mayPublish ? "publisher" : "viewer";
        },
    },
};
</script>
